type TS3File = {
  key: string;
};

export type TExportNotifyViaEmail = {
  recipients: string[];
  subject: string;
};

export enum ExportDataType {
  Distinct = 'distinct',
  Count = 'count',
  History = 'history',
  Total = 'total',
  WeeklyHotTopics = 'weekly-hot-topics',
  WeeklyContactLookup = 'weekly-contact-lookup',
  WeeklyPurchaseIntention = 'weekly-purchase-intention',
}

export type TGetExportDTO = {
  files: Array<TS3File>;
};

export type TGetExportConfigDTO = {
  id: string;
  name: string;
  isEnabled: boolean;
  directory?: string;
  format: 'csv' | 'xlsx';
  dataType: ExportDataType;
  requiredFields: Record<string, string>;
  exportTime: string;
  skipEmptyExport: boolean;
  isNonIncremental: boolean;
  notifyViaEmail?: TExportNotifyViaEmail;
};

export type TCreateExportConfigDTO = TGetExportConfigDTO;

export type TUpdateExportConfigDTO = TCreateExportConfigDTO;
export type TUpdateExportConfigStatusDTO = { status: boolean };
